<template>
    <div class="is-primary-modal-v2" :class="{ 'widget-modal': type === 'widget' }">
        <modal
            v-if="isShow && user && user.isAway && user.role !== 'observer'"
            :confirm="true"
            :type="'is-primary'"
            :size="'is-xsmall'"
            :title="'Are you still away?'"
            :hide-submit="false"
            :submit-text="'Set to active'"
            :cancel-text="'Remain away'"
            :submitDisabled="awayIsUpdating"
            @closed="closeModal"
            @submit="submit"
        >
            Would you like to switch to appear active?
        </modal>
    </div>
</template>

<script>
import { mapState } from 'pinia';
import stores from 'store/modules';
import ConversationsMixin from '../mixins/conversations';

export default {
    mixins: [ConversationsMixin],

    props: {
        type: { type: String, default: 'app' },
    },

    data() {
        return {
            isShow: false,
            awayIsUpdating: false,
        };
    },

    computed: {
        ...mapState(stores.User, ['user']),
    },

    methods: {
        init() {
            window.AwayStatusModal = this;

            if (window.localStorage.getItem('isAwayCounter') < 3 && this.user.isAway) {
                this.showModal();
            }
        },

        clearGlobalAwayTimer() {
            clearTimeout(window.globalAwayTimer);
            window.globalAwayTimer = null;
        },

        async showModal() {
            if (window.localStorage.getItem('isAway') === 'true') {
                localStorage.setItem('showedAwayStatusDate', new Date().toISOString());
                this.isShow = true;
                this.clearGlobalAwayTimer();
            }
        },

        async closeModal() {
            this.clearGlobalAwayTimer();
            this.awayIsUpdating = true;

            window.localStorage.setItem('awayStatusLastDate', new Date());

            try {
                const response = await this.$store.dispatch('updateAwayStatus', { status: true });
                this.$store.dispatch('setAwayStatus', { data: response });
            } catch (e) {
                this.$log.error(e, {}, 'toggleAwayStatus');
            } finally {
                this.isShow = false;
                this.awayIsUpdating = false;
            }
        },

        async submit() {
            this.clearGlobalAwayTimer();
            this.awayIsUpdating = true;

            try {
                const response = await this.$store.dispatch('updateAwayStatus', {
                    status: !this.user.isAway,
                });
                this.$store.dispatch('setAwayStatus', { data: response });

                if (this.$route.name === 'conversations.view' && this.$route.params.id) {
                    await this.$store.dispatch('getMessagesByConversationId', {
                        conversationId: this.$route.params.id,
                    });
                }

                this.$store.dispatch('updateStateMessages', { itemsLoadingForConversation: false });
            } catch (e) {
                this.$log.error(e, {}, 'toggleAwayStatus');
            } finally {
                this.isShow = false;
                this.awayIsUpdating = false;
            }
        },
    },

    mounted() {
        this.init();
    },
};
</script>
<style>
.is-primary-modal-v2 .modal {
    padding-top: 220px;
}
.is-primary-modal-v2.widget-modal .modal {
    padding: 20px;
}
.is-primary-modal-v2 .modal.is-primary.is-confirm .modal-card {
    background: #fff;
}
.is-primary-modal-v2 .modal .modal-card .modal-card-head .modal-card-title {
    color: #363636;
    text-shadow: none;
}
.is-primary-modal-v2 .modal .modal-card .modal-card-body {
    color: #7f7f7f;
    text-shadow: none;
}
.is-primary-modal-v2 .modal .modal-card .button.is-primary {
    background-color: #13b763;
    border-color: #13b763;
    color: white;
}
</style>
